/**
 * Environment configuration for Azure DevOps policy queries
 * Maps REACT_APP_NODE_ENV to cloud and environment values
 */

interface EnvironmentConfig {
  cloud: string;
  environment: string;
}

/**
 * Get the configuration based on the current environment
 * @returns Configuration object with cloud and environment
 */
export const getEnvironmentConfig = (): EnvironmentConfig => {
  const nodeEnv = process.env.REACT_APP_NODE_ENV?.toLowerCase();

  switch (nodeEnv) {
    case 'dev':
    case 'development':
      return {
        cloud: 'Public',
        environment: 'INT',
      };

    case 'aircapi':
      return {
        cloud: 'Aircapi',
        environment: nodeEnv,
      };

    case 'int':
      return {
        cloud: 'Public',
        environment: 'INT',
      };

    case 'prod':
    case 'production':
      return {
        cloud: 'Public',
        environment: 'PROD',
      };

    default:
      // Default to dev configuration
      return {
        cloud: 'Public',
        environment: 'INT',
      };
  }
};

/**
 * Current environment configuration
 */
export const environmentConfig = getEnvironmentConfig();
